<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 798.92 104.38"
        :class="class"
    >
        <path
            fill="currentColor"
            d="M65.94,2.55L24.11,101.83H0L41.83,2.55h24.11Z"
        />
        <path
            fill="currentColor"
            d="M108.14,35.74c2.55-8.65-1.4-11.06-8.35-11.06-5.53,0-10.3,3.26-11.11,6.52-2.72,11.06,42.88,10.78,29.19,43.4-1.75,4.25-17.28,29.36-50.9,29.36-30.35,0-28.91-19.15-23.58-31.63l26.25-5.25c-3.5,10.21.76,12.48,7.71,12.48s13.77-4.11,14.57-7.94c2.39-12.06-42.24-9.36-28.41-41.98,1.61-4.25,14.73-29.36,46.5-29.36,29.78,0,29.54,17.73,24.35,30.21l-26.25,5.25Z"
        />
        <path
            fill="currentColor"
            d="M179.97,2.55l-18.46,43.97h22.13L202.1,2.55h24.4l-41.83,99.28h-24.39l12.98-30.92h-22.13l-12.98,30.92h-24.39L155.58,2.55h24.39Z"
        />
        <path
            fill="currentColor"
            d="M279.3,69.92c-4,9.36-16.55,34.46-50.16,34.46s-25.04-25.1-21.04-34.46l14.95-35.46c3.86-9.36,16.55-34.46,50.16-34.46s24.89,25.1,21.04,34.46l-14.95,35.46ZM266.59,41.98c4.67-10.92,6.73-17.59-3.76-17.59s-13.98,6.67-18.65,17.59l-8.56,20.42c-4.67,10.92-6.73,17.59,3.76,17.59s13.98-6.67,18.64-17.59l8.56-20.42Z"
        />
        <path
            fill="currentColor"
            d="M311.59,2.55h25.81l-19.1,67.37L357.68,2.55h20.42l-17.26,67.37L398.39,2.55h25.81l-60.84,99.28h-27.8l8.22-42.12-27.22,42.12h-27.8L311.59,2.55Z"
        />
        <path
            fill="currentColor"
            d="M460.44,35.74c2.55-8.65-1.4-11.06-8.35-11.06-5.53,0-10.3,3.26-11.11,6.52-2.72,11.06,42.88,10.78,29.19,43.4-1.75,4.25-17.28,29.36-50.9,29.36-30.35,0-28.91-19.15-23.58-31.63l26.25-5.25c-3.5,10.21.76,12.48,7.71,12.48s13.78-4.11,14.57-7.94c2.39-12.06-42.24-9.36-28.41-41.98,1.61-4.25,14.73-29.36,46.5-29.36,29.78,0,29.54,17.73,24.35,30.21l-26.25,5.25Z"
        />
        <path
            fill="currentColor"
            d="M543.33,2.55c25.25,0,30.97,10.78,21.14,34.04-9.83,23.26-24.53,34.04-49.78,34.04h-11.06l-13.2,31.2h-24.39L507.88,2.55h35.46ZM525.8,46.23c6.81,0,10.56-.85,14.28-9.64,3.72-8.79.67-9.64-6.14-9.64h-11.91l-8.14,19.29h11.91Z"
        />
        <path
            fill="currentColor"
            d="M652.83,2.55l-10.25,24.39h-42.83l-5.47,13.05h30.49l-10.25,24.39h-30.49l-5.62,13.05h42.83l-10.25,24.39h-68.08L584.75,2.55h68.08Z"
        />
        <path
            fill="currentColor"
            d="M728.99,2.55l-10.25,24.39h-42.83l-5.47,13.05h30.49l-10.25,24.39h-30.49l-5.62,13.05h42.83l-10.25,24.39h-68.08L660.91,2.55h68.08Z"
        />
        <path
            fill="currentColor"
            d="M772.95,2.55c26.66,0,30.97,10.78,21.14,34.04l-13.16,31.06c-9.69,23.26-23.15,34.18-49.81,34.18h-35.88L737.07,2.55h35.88ZM741.79,77.44c6.81,0,10.77-1.13,14.28-9.64.04-.14,13.16-31.06,13.2-31.2,3.72-8.79.67-9.64-6.14-9.64h-11.91l-21.34,50.49h11.91Z"
        />
    </svg>
</template>
